import { NUM_CONFIRMATIONS } from "../config/constants";
import { getTokenAddress } from "../config/tokens";
import { getErc20Contract, getTokenxContract } from "./sf";

async function approveErc20Upgrade(chainId, signer, erc20Symbol, tokenxSymbol, amount) {
  const erc20 = await getErc20Contract(chainId, signer, erc20Symbol);
  const tokenxAddr = getTokenAddress(chainId, tokenxSymbol);

  let tx = await erc20.approve(tokenxAddr, amount);

  return tx.wait(NUM_CONFIRMATIONS);
}

async function getErc20Allowance(chainId, signer, accountAddr, erc20Symbol, tokenxSymbol) {
  const erc20 = await getErc20Contract(chainId, signer, erc20Symbol);
  const tokenxAddr = getTokenAddress(chainId, tokenxSymbol);

  return await erc20.allowance(accountAddr, tokenxAddr);
}

async function upgradeErc20(chainId, signer, tokenxSymbol, amount) {
  const tokenx = await getTokenxContract(chainId, signer, tokenxSymbol);
  let tx = await tokenx.upgrade(amount);

  return tx.wait(NUM_CONFIRMATIONS);
}

async function downgradeToken(chainId, signer, tokenxSymbol, amount) {
  const tokenx = await getTokenxContract(chainId, signer, tokenxSymbol);
  let tx = await tokenx.downgrade(amount);

  return tx.wait(NUM_CONFIRMATIONS);
}

export { upgradeErc20, downgradeToken, getErc20Allowance, approveErc20Upgrade };
